import type { BannerItem } from '@/types'
import Link from 'next/link'
import { type FC } from 'react'
import type { Settings } from 'react-slick'
import Slider from 'react-slick'
import CarrouselArrowIconMiddle from '../Icon/CarrouselArrowIconMiddle'
import ImageOptimize from '../ImageOptimize'

interface Props {
  sliders: Array<BannerItem>
}
export const BannerBlog: FC<Props> = ({ sliders }: Props) => {
  const settings: Settings = {
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    variableWidth: false,
    nextArrow: <CarrouselArrowIconMiddle type='next' />,
    prevArrow: <CarrouselArrowIconMiddle type='prev' />,
  }

  return sliders.length ? (
    <Slider {...settings} className='mb-[10px] flex flex-wrap gap-[20px]'>
      {sliders &&
        sliders.map((slider: BannerItem, index: number) => (
          <Link
            className='block w-full overflow-hidden rounded-lg'
            href={slider.link || '/'}
            key={index}
          >
            <ImageOptimize
              className='h-[250px] w-full'
              src={slider.image}
              alt={slider.title}
              width={1366}
              quality={100}
              height={717}
            />
          </Link>
        ))}
    </Slider>
  ) : null
}
